export const REACT_APP_API_URL = process.env.REACT_APP_API_URL || "https://mandir-api.atlas.innpact.ai";
export const REACT_APP_MATTERPORT_SDK_KEY = process.env.REACT_APP_MATTERPORT_SDK_KEY || '';
// export const REACT_APP_API_URL = "http://localhost:8000";

// Timing Constants
export const TIMING = {
  POPUP: {
    SHOW_DELAY: 500,        // Delay before showing popup (ms)
    HIDE_DELAY: 6000,       // Time before auto-hiding popup (ms)
    PROGRESS_DURATION: 6000 // Duration of progress bar animation (ms)
  },
  MATTERPORT: {
    SCRIPT_CHECK_INTERVAL: 500,    // Interval to check if SDK is loaded (ms)
    MAX_SCRIPT_CHECK_ATTEMPTS: 20, // Maximum attempts to check for SDK
    CAMERA_TRANSITION: 1000,       // Camera transition duration (ms)
    TAG_OPEN_DELAY: 1500,         // Delay before opening tag content (ms)
    INIT_DELAY: 1000,             // Delay before initialization (ms)
    AUTO_NAVIGATE_DELAY: 5000,     // Delay before auto-navigation (ms)
    CHAT_OPEN_DELAY: 1500         // Delay before opening chat (ms)
  },
  AUDIO: {
    IDLE_TIMEOUT_MS: 60_000,     // Inactivity duration before fading audio out (ms)
    IDLE_FADE_DURATION_S: 10,    // Seconds to fade to silence on idle
    IDLE_RESTORE_DURATION_S: 3   // Seconds to fade back in on user return
  },
  TRANSITIONS: {
    OPACITY: 1000,  // Opacity transition duration (ms)
    TRANSFORM: 200  // Transform transition duration (ms)
  }
};

// Z-Index Constants
export const Z_INDEX = {
  LOADER: 10,
  TAG_OVERLAY: 5,
  TAG_LANG_TOGGLE: 6,
  TAG_SIDEBAR: 50,
  QUICK_NAV: 10001,
  CHAT_BUTTON: 1000,
  CHAT_WINDOW: 2000,
  POPUP: 2500,
  LOGO: 1000,
  AUDIO_PLAYER: 10002,
  AUDIO_DEBUG: 10003,
  VIDEO_DEBUG: 10004,
  TOUR_OVERLAY: 10000,
  TOUR_SLIDESHOW: 9999,
  // Fullscreen image overlay that replaces the Matterport iframe for
  // configured stops (e.g. Abhishek Hall). Sits above the tour-running
  // pointer blocker (TOUR_SLIDESHOW) but below the temple header / footer
  // dock (10001) so navigation chrome remains accessible.
  LOCATION_IMAGE_OVERLAY: 10000,
  AMENITY_SLIDESHOW: 10050,
  DRONE_POI_PANEL: 10005,
  FLOOR_PLAN_MINIMAP: 60,
  MEDIA_TRAY: 150,
  MEDIA_LIGHTBOX: 10100,
  POI_CREATOR: 10200,
  POI_EDITOR: 10201,
  ZONE_TOOL: 10202,
  SIGNAGE_EDITOR: 10203,
  // Custom nav hints sit BELOW the floating UI (quick-nav, audio player,
  // header/logo, language buttons) so they never overlap those controls.
  NAV_HINT_CUSTOM: 80,
  NAV_HINTS: 10300,
  NAV_HINT_CARD: 10301,
  NAV_HINTS_EDITOR: 10302,
  QUICK_NAV_EDITOR: 10303,
};

// Camera Constants
export const CAMERA = {
  ZOOM: {
    IN_FACTOR: 0.8,
    OUT_FACTOR: 1.2
  },
  ROTATION: {
    STEP: 0.5 // Rotation step in radians
  }
};

// Fallback Sweep IDs
export const FALLBACK_SWEEP_IDS = [
  '4257b9eaa29f446e8e12858e237db8c6',
  'f960b37050a7455887aa6b04e8f281a0',
  'ad648d6d46c449bab72ec8bd8c384e5d',
  '4qw2gm54iwzz7wxtdg01i0nrd'
];

// UI Constants
export const UI = {
  CHAT: {
    MAX_HEIGHT_MOBILE: 'calc(100vh - 96px)',
    ICON_SIZE: {
      DEFAULT: 24,
      SMALL: 16,
      TINY: 12
    }
  },
  LOADER: {
    SIZE: {
      WIDTH: 12,
      HEIGHT: 12,
      BORDER: 4
    }
  },
  SPACING: {
    MOBILE: {
      BOTTOM: 4,
      RIGHT: 4
    },
    DESKTOP: {
      BOTTOM: 20,
      RIGHT: 8
    }
  }
};

// Drone Aerial View Configuration
export const VIEW_360_CONFIG = {
  views: [
    {
      id: 'topView',
      label: 'Top View',
      image: '/assets/images/drone_images/top_view.JPG'
    }
  ]
};
